import { Injectable } from '@angular/core';
import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGES } from '@app/shared/constants/language.contant';
import { transformToLanguageCodesArray } from '@app/shared/utils/language.util';
import { TranslateService } from '@ngx-translate/core';
import { EnvConfigService, VersionService, OidcAuthService, ThemeService } from 'ngx-mat-esign360';
import { isLanguageSupported } from 'ngx-mat-esign360/lib/shared/utils/language.util';

@Injectable({
  providedIn: 'root',
})
export class InitializerService {
  constructor(
    private envConfig: EnvConfigService,
    private versionService: VersionService,
    private authService: OidcAuthService,
    private translate: TranslateService,
    private themeService: ThemeService
  ) {}

  async init(): Promise<any> {
    return this.themeService
      .load()
      .toPromise()
      .then(() => this.envConfig.load().toPromise())
      .then((envData) => {
        this.versionService.printVersion();
        this.versionService.checkVersion(() => localStorage.clear());

        const languageCode =
          envData.defaultLang &&
          isLanguageSupported(
            envData.defaultLang,
            transformToLanguageCodesArray(SUPPORTED_LANGUAGES)
          )
            ? envData.defaultLang
            : DEFAULT_LANGUAGE_CODE;

        this.translate.setDefaultLang(languageCode);
        return Promise.all([
          this.translate.use(languageCode).toPromise(),
          this.authService.init('start-signing'),
        ]);
      });
  }
}
